<template>
  <div class="view-tools-integrations-zoom">
    <view-container
      title="Zoom"
      subtitle="Integre sua conta do Zoom à Blitzpay."
      :breadcrumbs="breadcrumbs"
      header
    >
      <action-dispatcher action="product/get" :parameters="{ limit: 1000 }">
        <form-group
          v-model="form.product_id"
          id="product-select"
          label="Selecione o produto"
          placeholder="Selecione o produto"
          select
          slim
          :options="[...products.map(({ id, name }) => ({ id, name }))]"
        />
        <template v-if="form.product_id">
          <div class="d-flex justify-content-between my-6">
            <button class="btn p-0 table-refresh" @click="dispatch">
              <i class="fa-solid fa-refresh" />
            </button>
            <div
              @mouseover="showTooltip"
              @mouseleave="hideTooltip"
              class="tooltip-wrapper position-relative"
            >
              <b-dropdown
                right
                text="Right align"
                class="btn-sm btn-40 btn-new-primary font-weight-semibold btn-40 py-0 pl-5 pr-6"
                :class="{
                  disabled: !!integration
                }"
                :toggle-class="{
                  disabled: !!integration
                }"
                :disabled="!!integration"
              >
                <template #button-content>
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <i class="icon-plus pr-5"></i>
                    <span class="pr-5">Adicionar</span>
                    <i class="icon-angle-down fs-16"></i>
                  </div>
                </template>
                <b-dropdown-item @click="openModal">
                  Nova integração
                </b-dropdown-item>
                <b-dropdown-item @click="openCopyModal">
                  Copiar dados de integração existente
                </b-dropdown-item>
              </b-dropdown>
              <div v-if="tooltip" class="tooltip-box">
                Você só pode adicionar uma integração por produto. Caso deseje
                cadastrar outra, exclua a integração atual.
              </div>
            </div>
          </div>
          <div v-if="loading" class="d-flex justify-content-center p-9">
            <b-spinner variant="primary" style="width: 3rem; height: 3rem;" />
          </div>
          <div v-else-if="!integration">
            <div class="centering text-center pt-9">
              <img
                class="d-block mb-6 mx-auto"
                src="@/assets/images/home/welcome.png"
              />
              <h4 class="text-dark mb-6">Ainda não há nada aqui</h4>
              <p>Não há uma conta cadastrada até o momento.</p>
            </div>
          </div>
          <div v-else>
            <div class="row d-none d-lg-flex mb-6">
              <div class="col-lg-5"><h6>Client_id</h6></div>
              <div class="col-lg-5"><h6>Client_secret</h6></div>
              <div class="col-lg-2"></div>
            </div>
            <div class="row align-items-center">
              <div class="col-lg-5 order-1 mb-6 mb-lg-0 text-truncate">
                <span class="font-weight-bold d-block d-lg-none mr-3">
                  Client_id: </span
                >{{ integration.client_id }}
              </div>
              <div class="col-lg-5 order-2 mb-6 mb-lg-0 text-truncate">
                <span class="font-weight-bold d-block d-lg-none mr-3"
                  >Client_secret: </span
                >{{ integration.client_secret }}
              </div>
              <div class="col-lg-2 order-0 order-lg-4">
                <div class="d-flex align-items-center justify-content-end">
                  <actions-dropdown
                    :left="false"
                    :right="true"
                    :actions="actions"
                    @edit="onEdit"
                    @delete="submitDelete"
                  />
                </div>
              </div>
            </div>
            <hr />
          </div>
        </template>
        <template v-else>
          <p class="text-center mt-9 text-secondary">
            Primeiro selecione o produto
          </p>
        </template>
        <responsive-modal v-model="modal" size="lg">
          <zoom-modal
            :form="form"
            :errors="errors"
            :loading="loading"
            @submit="submit"
            @close="close"
          />
        </responsive-modal>
        <responsive-modal v-model="copyModal" size="lg">
          <zoom-copy-modal
            :form="form"
            :errors="errors"
            :loading="loading"
            @submit="submit"
            @close="close"
          />
        </responsive-modal>
      </action-dispatcher>
    </view-container>
  </div>
</template>
<script>
import ZoomCopyModal from "@/components/tools/modals/ZoomCopyModal.vue";
import ZoomModal from "@/components/tools/modals/ZoomModal.vue";
import { mapState } from "vuex";

export default {
  components: { ZoomModal, ZoomCopyModal },
  data() {
    return {
      loading: false,
      tooltip: false,
      form: {
        product_id: "",
        client_id: "",
        client_secret: ""
      },
      errors: {
        client_id: [],
        client_secret: []
      },
      modal: false,
      copyModal: false,
      integration: null
    };
  },
  computed: {
    ...mapState("product", ["products"]),
    breadcrumbs() {
      return [
        {
          link: "tools",
          title: "Ferramentas"
        },
        { title: "Zoom" }
      ];
    },
    actions() {
      return [
        {
          text: "Editar",
          class: "",
          icon: "fa-solid fa-pen",
          confirmation: {
            enable: false,
            text: ""
          },
          event: "edit"
        },
        {
          text: "Excluir",
          class: "text-danger",
          icon: "icon-trash",
          confirmation: {
            enable: true,
            newDesign: true,
            submitButtonClass: "btn-danger",
            text: "Deseja mesmo excluir esta integração?"
          },
          event: "delete"
        }
      ];
    }
  },
  watch: {
    "form.product_id"() {
      this.dispatch();
    }
  },
  methods: {
    showTooltip() {
      if (this.integration) {
        this.tooltip = true;
      }
    },
    hideTooltip() {
      this.tooltip = false;
    },
    openCopyModal() {
      if (!this.integration) {
        this.copyModal = true;
      }
    },
    openModal() {
      if (!this.integration) {
        this.modal = true;
      }
    },
    onEdit() {
      this.modal = true;
    },
    close() {
      this.form.client_id = "";
      this.form.client_secret = "";
      this.errors = {
        client_id: [],
        client_secret: []
      };
      this.modal = false;
      this.copyModal = false;
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("integration/getAllZoom", {
          product_id: this.form.product_id
        })
        .then(data => {
          if (data.length) {
            this.integration = { ...data[0] };
            this.form.client_id = data[0].client_id;
            this.form.client_secret = data[0].client_secret;
          } else {
            this.integration = null;
            this.form.client_id = "";
            this.form.client_secret = "";
          }
        })
        .catch(e => {
          // this.$message.warning(
          //   "Não foi possível obter as integrações do servidor."
          // );
        })
        .finally(() => {
          this.loading = false;
        });

      this.$store.dispatch("integration/getAllZoom", {}).then();
    },
    submitDelete() {
      if (this.loading) return;

      this.loading = true;
      this.$store
        .dispatch("integration/deleteZoom", this.integration.id)
        .then(data => {
          this.$message.success("Integração excluída com sucesso!");
          this.dispatch();
        })
        .catch(e => {
          this.$message.error("Não foi possível excluir a integração");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    submit() {
      if (this.loading) return;

      if (!this.form.client_id || !this.form.client_id.length) {
        this.errors.client_id = [
          "Por favor, insira o client_id antes de integrar"
        ];
        return;
      }

      if (!this.form.client_secret || !this.form.client_secret.length) {
        this.errors.client_id = [
          "Por favor, insira o client_secret antes de integrar"
        ];
        return;
      }

      let action = this.integration
        ? "integration/putZoom"
        : "integration/postZoom";

      let payload = { ...this.form };

      if (this.integration) {
        payload = {
          ...this.integration,
          ...payload
        };
      }

      this.loading = true;

      this.$store
        .dispatch(action, payload)
        .then(data => {
          this.$message.success("Integração salva com sucesso!");
          this.close();
          this.dispatch();
        })
        .catch(e => {
          this.$message.error("Não foi possível salvar a integração");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.view-tools-integrations-zoom {
  .tooltip-box {
    border-radius: 4px;
    background: #393444;
    padding: 7px 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    z-index: 999;
    width: 280px;

    position: absolute;
    top: 110%;
    right: 50%;

    @media screen and (max-width: 991px) {
      right: 0%;
      font-size: 12px;
      width: 230px;
    }
  }

  .row {
    @media screen and (max-width: 991px) {
      font-size: 14px;
    }
  }

  .disabled,
  ::v-deep .btn-secondary.disabled,
  .btn-secondary:disabled,
  .btn-new-primary:disabled {
    color: var(--l-neutral-45, rgba(87, 88, 107, 0.88)) !important;
    border-color: rgba(119, 120, 142, 0.08) !important;
    background-color: rgba(119, 120, 142, 0.08) !important;
    cursor: not-allowed;
  }

  ::v-deep .btn {
    &.dropdown-toggle {
      background-color: unset !important;
      min-height: 40px;
      padding: 0 16px;
      border: unset !important;

      position: relative;
      &::after {
        content: none;
      }
    }
  }
  .dropdown-item {
    a {
      color: unset !important;
    }
  }
}
</style>
